import Swal from 'sweetalert2';

import { escapeHtml } from '../utils/html';

import IconWarning from '../assets/images/icon-warning.png'
import IconError from '../assets/images/icon-error.png';
import IconSuccess from '../assets/images/icon-success.png';

/**
 * Todos estos helpers arman el popup con la opcion `html` de SweetAlert, o sea que el
 * texto se inyecta como markup. Por eso se escapa por defecto.
 *
 * `html: true` desactiva el escape para el caso en que el llamador necesita armar
 * markup a proposito (una lista de errores, por ejemplo). Quien lo use se hace cargo
 * de escapar las partes que no controla — ver `escapeHtml`.
 */
const render = (value, html) => (html ? (value || '') : escapeHtml(value));

export const showAlertMessage = async ({title = '', text = '', error = false, html = false, textCloseButton = 'Cerrar'}) => {
    const img = `<img src=${ error ? IconError : IconSuccess } class="swal-icon" alt="icon warning" />`;

    return Swal.fire({
        html: `<div class="swal-container-confirmation">
            <h1 class="swal-title">${render(title, html)}</h1>
            <p class="swal-text">${render(text, html)}</p>
            ${img}
        </div>`,
        showConfirmButton: false,
        showCancelButton: true,
        showCloseButton: false,
        reverseButtons: true,
        cancelButtonText: textCloseButton,
        customClass: {
            cancelButton: "swal-confirm-button-confirmation",
        },
        backdrop: `rgba(228, 228, 228, 0.6)`
      })
}

export const showConfirmation = async ({title = '', text = '', icon = false, textConfirmButton = 'Sí, confirmar', popupClass = '', html = false}) => {
    const img = icon ? `<img src=${ IconWarning } class="swal-icon" alt="icon warning" />` : '';

    return Swal.fire({
        html: `<div class="swal-container-confirmation swal-container-confirmation--table">
            <h1 class="swal-title">${render(title, html)}</h1>
            <p class="swal-text">${render(text, html)}</p>
            ${img}
        </div>`,
        showCancelButton: true,
        showCloseButton: true,
        reverseButtons: true,
        confirmButtonText: textConfirmButton,
        cancelButtonText: 'Cancelar',
        customClass: {
            popup: popupClass,
            cancelButton: "swal-cancel-button-confirmation",
            confirmButton: "swal-confirm-button-confirmation"
        },
        backdrop: `rgba(228, 228, 228, 0.6)`
      })
}

export const showConfirmSaved = async ({title = '', text = '', icon = false, textConfirmButton = 'Sí, confirmar', showCloseButton = false, html = false}) => {
    const img = icon ? `<img src=${ IconWarning } class="swal-icon" alt="icon warning" />` : '';
    return Swal.fire({
        html: `<div class="swal-container-confirmation swal-container-confirmation--confirm-saved">
            <h1 class="swal-title swal-title--confirm-saved">${render(title, html)}</h1>
            <p class="swal-text">${render(text, html)}</p>
            ${img}
        </div>`,
        position: 'center-end',
        showCancelButton: true,
        showCloseButton,
        reverseButtons: true,
        confirmButtonText: textConfirmButton,
        cancelButtonText: 'Cancelar',
        customClass: {
            cancelButton: "swal-cancel-button-confirmation",
            confirmButton: "swal-confirm-button-confirmation"
        },
        backdrop: `rgba(228, 228, 228, 0.6)`
      })
}

export const showError = async ({ message, timer, html = false }) => {
    Swal.fire({
        html: `<div class="swal-container-error">
        <img src=${IconError} class="swal-icon" alt="red alert" />
        <p class="swal-text mb-0">${ message ? render(message, html) : 'Ocurrió un error. Reinténtalo.'}</p>
        </div>`,
        timer: timer ? timer : 3000,
        showConfirmButton: false,
        background: 'hsla(0, 0%, 77%, 0)',
        backdrop: true,
        position: 'top-end',
        width: 0
    });
}


export const showSuccess = async ({ message, timer, html = false }) => {
    Swal.fire({
        html: `<div class="swal-container-success">
        <img src=${IconSuccess} class="swal-icon" alt="green check" />
        <p class="swal-text mb-0">${ message ? render(message, html) : 'Se completó la tarea con éxito.'}</p>
        </div>`,
        timer: timer ? timer : 3000,
        showConfirmButton: false,
        background: 'hsla(0, 0%, 77%, 0)',
        backdrop: true,
        position: 'top-end',
        width: 0
    });
}